import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthErrorService {
	private readonly errorMessageSubject = new BehaviorSubject<string | null>(null);
	errorMessage$ = this.errorMessageSubject.asObservable();

	setError(message: string) {
		console.log('setError', message);
		this.errorMessageSubject.next(message);
	}

	clearError() {
		this.errorMessageSubject.next(null);
	}
}
